<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">{{ operacion }}Obra Social</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-3 mb-0 align-items-center">
            <div class="mb-3 mt-0 text-start ">
                <form (ngSubmit)="saveObraSocial()" [formGroup]="moreObraSocial">
                    <div class="mb-4 mt-2 text-start ">
                        <label for="descripcion" class="form-label"><b>Descripción</b></label>
                        <textarea
                            class="form-control textarea-description"
                            id="descripcion"
                            formControlName="descripcion"
                            rows="1"
                            placeholder="Ingrese una descripción"
                            (input)="autoGrow($event)">
                        </textarea>
                        @if (moreObraSocial.controls['descripcion'].invalid && (moreObraSocial.controls['descripcion'].dirty || moreObraSocial.controls['descripcion'].touched) && moreObraSocial.controls['descripcion'].errors?.['required']) {
                            <div class="alert-danger" role="alert"><small class="alert">La descripción es requerida</small></div>
                        }
                    </div>
                    @if (error()) {
                        <div class="alert alert-danger mt-2" role="alert">
                            <small>{{ error() }}</small>
                        </div>
                    }
                    <div class="d-grid mt-5 mb-2">
                        <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">{{(loading()) ? 'Cargando...' : botonOperacion+'Obra Social'}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>